import React from 'react';
import PropTypes from 'prop-types';
import { rd } from '@passionware/monads';
import { useSelector } from 'react-redux';
import { getProductionStatus } from 'store/v1/productions/productions.selectors';
import { Status } from 'v1/components/shared';
import { useBrowsingRoleMissingDays } from 'v5/services/internal/SystemSettingsService/legacyRoleMissingDays.connected';

import './ProductionStatus.scss';

const ProductionStatus = ({ production, appearance, style }) => {
  const alertDayCount = rd.tryGet(useBrowsingRoleMissingDays())?.value;
  const status = useSelector(state =>
    getProductionStatus(state, production, alertDayCount)
  );

  return <Status statusId={status.id} appearance={appearance} style={style} />;
};

ProductionStatus.propTypes = {
  production: PropTypes.object,
  appearance: PropTypes.oneOf(['compact', 'expanded']),
  style: PropTypes.object
};

export default ProductionStatus;
